// extracted by mini-css-extract-plugin
module.exports = {"bodyText":"_3Gsa7z8","h5Text":"_3TgIufG","h4Text":"_3tsdfRy","h3Text":"_2X990kB","srOnly":"IZNe-o8","link":"_38qSXhG _3Gsa7z8","germanVATInc":"_3BT-YhX"};